"use client";

import {
    createContext,
    useContext,
    useState,
    ReactNode,
} from "react";

type MediaType = "img" | "vid" | "auo";

interface MediaContextType {
    open: boolean;
    setOpen: (value: boolean) => void;

    types: MediaType[];
    setTypes: (value: MediaType[]) => void;

    multiple: boolean;
    setMultiple: (value: boolean) => void;

    onSelect: ((files: string[]) => void) | null;
    setOnSelect: (callback: ((files: string[]) => void) | null) => void;

    openPicker: (
        types: MediaType[],
        multiple: boolean,
        callback: (files: string[]) => void
    ) => void;
}

const MediaContext = createContext<MediaContextType | null>(null);

export function MediaProvider({ children }: { children: ReactNode }) {

    const [open, setOpen] = useState(false);
    const [types, setTypes] = useState<MediaType[]>([]);
    const [multiple, setMultiple] = useState(false);

    const openPicker = (
        types: MediaType[],
        multiple: boolean,
        callback: (files: string[]) => void
    ) => {

        setTypes(types);
        setMultiple(multiple);
        setOnSelect(() => callback);
        setOpen(true);

    };

    const [onSelect, setOnSelect] =
        useState<((files: string[]) => void) | null>(null);

    return (
        <MediaContext.Provider
            value={{
                open,
                setOpen,

                types,
                setTypes,

                multiple,
                setMultiple,

                onSelect,
                setOnSelect,

                openPicker,
            }}
        >
            {children}
        </MediaContext.Provider>
    );
}

export function useMediaContext() {
    const context = useContext(MediaContext);

    if (!context) {
        throw new Error("useMediaContext must be used inside MediaProvider");
    }

    return context;
}